const defaultConfig = {
  appVersion: '2.0.5'
}
export default defaultConfig
